import React, { useRef, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import useProfilePhoto from "../../../utilities/useProfilePhoto";
import ProfilePhotoBanner from "../../../components/ProfilePhotoBanner";

const PhotoStep = ({ profile, onComplete }) => {
  const { t } = useTranslation();
  const inputFile = useRef(null);
  const { loading, previewUrl, upload, defaultFocal } = useProfilePhoto();
  const [uploaded, setUploaded] = useState(false);
  const [focalX, setFocalX] = useState(profile?.photoFocalX ?? defaultFocal.x);
  const [focalY, setFocalY] = useState(profile?.photoFocalY ?? defaultFocal.y);

  const photoUrl = previewUrl || profile?.imageUrl;
  const hasPhoto = Boolean(uploaded || photoUrl);

  const handleChange = async (event) => {
    const file = event.target.files[0];
    event.target.value = "";
    if (!file) return;
    setFocalX(defaultFocal.x);
    setFocalY(defaultFocal.y);
    const ok = await upload(file);
    if (ok) setUploaded(true);
  };

  return (
    <Box sx={{ width: "100%", textAlign: "center" }}>
      <ProfilePhotoBanner
        photoUrl={photoUrl}
        loading={loading}
        focalX={focalX}
        focalY={focalY}
        onSaved={(x, y) => {
          setFocalX(x);
          setFocalY(y);
        }}
        onPickPhoto={() => inputFile.current.click()}
        showCameraBadge={hasPhoto}
      />

      <Box sx={{ px: 3, pt: 3 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          {t("setup.photo.title")}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {hasPhoto && !loading
            ? t("setup.photo.confirm.body")
            : t("setup.photo.body")}
        </Typography>

        <input
          type="file"
          accept="image/*"
          capture="user"
          ref={inputFile}
          onChange={handleChange}
          style={{ display: "none" }}
        />

        {hasPhoto && !loading ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Button
              className="tnfm-pill-btn"
              variant="contained"
              fullWidth
              onClick={onComplete}
            >
              {t("setup.photo.confirm.cta")}
            </Button>
            <Button
              className="tnfm-pill-btn"
              variant="text"
              fullWidth
              onClick={() => inputFile.current.click()}
            >
              {t("setup.photo.retake")}
            </Button>
          </Box>
        ) : (
          <Button
            className="tnfm-pill-btn"
            variant="contained"
            fullWidth
            disabled={loading}
            onClick={() => inputFile.current.click()}
          >
            {t("setup.photo.cta")}
          </Button>
        )}
      </Box>
    </Box>
  );
};

PhotoStep.bleed = true;

export default PhotoStep;
